'use client'

import { TransitionChild } from '@headlessui/react'
import { forwardRef } from 'react'

import { cn } from '@src/utils/tailwind'

export const ModalBackdrop = forwardRef<HTMLDivElement, { className?: string }>(
  ({ className }, ref) => {
    return (
      <TransitionChild>
        <div
          ref={ref}
          className={cn(
            'fixed inset-0 bg-bodi-black-text/80 transition-opacity duration-200',
            'data-closed:opacity-0 data-enter:duration-150 data-enter:ease-out data-leave:duration-150 data-leave:ease-in',
            className
          )}
        />
      </TransitionChild>
    )
  }
)

ModalBackdrop.displayName = 'ModalBackdrop'
